<template>
  <step :key="key" :data="currentStep" @success="nextStep" @ended="$emit('ended')"></step>
</template>

<script>
import cuid from "cuid";

import Step from "@/components/Interactive/Step/";

export default {
  name: "Interactive",
  components: { Step },
  props: {
    steps: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    currentStep() {
      const { steps, isStep } = this;
      return steps[isStep];
    },
  },
  data: () => ({
    key: cuid(),

    isStep: 0,
  }),
  methods: {
    nextStep() {
      const { steps, isStep } = this;

      if (isStep + 1 === steps.length) {
        this.$emit("success");
      } else {
        this.isStep++;
        this.key = cuid();
      }
    },
  },
};
</script>
